(function () {
  'use strict';

  angular.module('app').component('bookingItemList', bookingItemList());

  function bookingItemList() {
    return {
      bindings: {
        item: '=',
      },
      controller: BookingItemsList,
      controllerAs: 'vm',
      templateUrl:
        './app/ajs/bookings/booking-items/booking-item-list/booking-item-list.component.html',
    };
  }

  BookingItemsList.$inject = [
    'CONFIGURATIONS',
    'UtilService',
    'moment',
    'BookingService',
    'BookingItemNotificationService',
    'MeasurementUnitService',

    // Angular downgraded service
    'companyService',
  ];

  function BookingItemsList(
    config,
    UtilService,
    moment,
    BookingService,
    BookingItemNotificationService,
    MeasurementUnitService,

    // Angular downgraded service
    companyService
  ) {
    var vm = this;

    vm.UtilService = new UtilService(vm);
    vm.dateDisplay = config.DATE_DISPLAY_SHORT; // month day, year
    vm.hourDisplay = config.HOUR_DISPLAY; // hh:mm a

    // Methods
    vm.getTotalPax = getTotalPax;
    // vm.getVoucher = getVoucher;
    // vm.sendVoucher = sendVoucher;

    vm.openUpdateBookingItemNotification = openUpdateBookingItemNotification;
    vm.openBookingItemNotificationInfo = openBookingItemNotificationInfo;
    vm.openSendBookingItemNotificationToProvider = openSendBookingItemNotificationToProvider;

    vm.$onInit = function () {
      // Initializers
      getCompany();
    };

    function getCompany() {
      vm.loadingCurrenciesPerCompany = true;

      vm.loadingCompany = true;
      companyService
        .getCompany(vm.item.company_id, { skip_check_role: true })
        .subscribe((response) => {
          vm.company = response;

          setBookingItems();
          getStartAndEndDates();

          vm.loadingCompany = false;
        });
    }

    // Set related data to each booking item / booking item service item
    function setBookingItems() {
      var bookingItemMeasurementUnits, bookingItemServiceItemMeasurementUnits;
      vm.item.booking_items.forEach(function (bookingItem) {
        bookingItemMeasurementUnits = MeasurementUnitService.setMeasurementUnitsByProductType(
          vm.company.measurement_units,
          bookingItem.booking_type
        );
        bookingItem.measurement_unit = vm.UtilService.findItemInArray(
          bookingItemMeasurementUnits,
          'id',
          bookingItem.measurement_unit_id
        );

        if (bookingItem.based_on_service_items && bookingItem.booking_item_service_items) {
          bookingItem.booking_item_service_items.forEach(function (bookingItemServiceItem) {
            bookingItemServiceItemMeasurementUnits =
              MeasurementUnitService.setMeasurementUnitsByProductType(
                vm.company.measurement_units,
                'service_item'
              );
            bookingItemServiceItem.measurement_unit = vm.UtilService.findItemInArray(
              bookingItemServiceItemMeasurementUnits,
              'id',
              bookingItemServiceItem.measurement_unit_id
            );
          });
        }
      });
    }

    // get the start and end dates to each booking item
    function getStartAndEndDates() {
      var first_tour = vm.item.booking_items[0];
      var last_tour = vm.item.booking_items[vm.item.booking_items.length - 1];

      if (first_tour !== null) {
        vm.startDate = moment(first_tour.start_date).format(vm.dateDisplay);
      } else {
        vm.startDate = moment().format(vm.dateDisplay);
      }

      if (last_tour !== null) {
        if (last_tour.end_date === null) {
          vm.endDate = moment(last_tour.start_date).format(vm.dateDisplay);
        } else {
          vm.endDate = moment(last_tour.end_date).format(vm.dateDisplay);
        }
      } else {
        vm.endDate = moment().format(vm.dateDisplay);
      }

      generateDaysArray();
    }

    // generate the day for each booking item - DRY
    function generateDaysArray() {
      var start_date = moment(vm.startDate);
      var end_date = moment(vm.endDate);
      var daysArray = [];
      var day = 1;

      if (vm.item.booking_items.length) {
        while (start_date <= end_date) {
          daysArray.push({
            day: day,
            date: start_date.format('YYYY-MM-DD'),
          });
          day += 1;
          start_date.add(1, 'day');
        }

        vm.item.booking_items.forEach(function (booking_item) {
          if (booking_item.end_date === null) {
            daysArray.forEach(function (day) {
              if (booking_item.start_date === day.date) {
                booking_item.day = day.day;
              }
            });
          } else {
            var days = '';
            daysArray.forEach(function (day) {
              if (booking_item.start_date === day.date) {
                days = day.day + '-';
              } else if (booking_item.end_date === day.date) {
                days = days + day.day;
              }
            });
            booking_item.day = days;
          }
        });
      }

      vm.item.days = daysArray.length;
      vm.item.nights = vm.item.days - 1;
    }

    // get voucher on PDF
    /* function getVoucher(item) {
      BookingService.getVoucher(item.id, item.booking_id).then(function () {
        var blobVar = new Blob([BookingService.data], { type: 'application/pdf' });

        // TODO: willy, fix this
        // saveAs(blobVar, 'voucher ' + item.booking_item_number + '.pdf');
      });
    }
 */
    // send voucher mail to client
    /* function sendVoucher(item) {
      var params = {
        booking_item_id: item.id,
        confirmed_option: 'voucher',
      };

      setTimeout(function () {
        // Delay x sec
        BookingService.sendBookingToClient(vm.item.id, params).then(function (response) {});
      }, 500);
    } */

    function getTotalPax(adults, children, infants, seniors) {
      return BookingService.getTotalPax(adults, children, infants, seniors, 'short');
    }

    // BOOKING ITEM ACTIONS

    function openUpdateBookingItemNotification(bookingItem) {
      var successCallback = function (bookingItemObj) {
        BookingService.getBooking(vm.item.id).then(function (data) {
          vm.item.status = data.status;
        });
      };

      BookingItemNotificationService.openUpdateBookingItemNotification(
        vm.item,
        bookingItem,
        bookingItem.notification,
        successCallback
      );
    }

    function openBookingItemNotificationInfo(bookingItem) {
      BookingItemNotificationService.openBookingItemNotificationInfo(
        vm.item,
        bookingItem,
        bookingItem.notification
      );
    }

    function openSendBookingItemNotificationToProvider(bookingItem) {
      var successCallback = function (data) {
        // status
        bookingItem.status = data.status;
        bookingItem.notification = data.notification;
      };

      BookingItemNotificationService.openSendBookingItemNotificationToProvider(
        vm.item.company_id,
        bookingItem,
        bookingItem.notification,
        successCallback
      );
    }
  }
})();
